import { TEXT_STYLES } from '../../constants/styles';

function ProjectGoal({ title = 'Goal', description }) {
  if (!description) return null;

  return (
    <div className="space-y-6">
      <div className="prose prose-lg">
        {title && (
          <h2 className={TEXT_STYLES.subheading + ' mb-2'}>
            {title}
          </h2>
        )}
        <p className={TEXT_STYLES.body}>
          {description}
        </p>
      </div>
    </div>
  );
}

export default ProjectGoal;

